export default {"src":"/_next/static/media/ico_message.a24a61b4.svg","height":18,"width":18};